// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicWalletGetCurrencyChains (params?: {}): Promise<List>;
    publicUnifiedGetCurrencies (params?: {}): Promise<List>;
    publicUnifiedGetHistoryLoanRate (params?: {}): Promise<Dict>;
    publicSpotGetCurrencies (params?: {}): Promise<List>;
    publicSpotGetCurrenciesCurrency (params?: {}): Promise<Dict>;
    publicSpotGetCurrencyPairs (params?: {}): Promise<List>;
    publicSpotGetCurrencyPairsCurrencyPair (params?: {}): Promise<Dict>;
    publicSpotGetTickers (params?: {}): Promise<List>;
    publicSpotGetOrderBook (params?: {}): Promise<Dict>;
    publicSpotGetTrades (params?: {}): Promise<List>;
    publicSpotGetCandlesticks (params?: {}): Promise<List>;
    publicSpotGetTime (params?: {}): Promise<Dict>;
    publicSpotGetInsuranceHistory (params?: {}): Promise<List>;
    publicMarginGetUniCurrencyPairs (params?: {}): Promise<List>;
    publicMarginGetUniCurrencyPairsCurrencyPair (params?: {}): Promise<Dict>;
    publicMarginGetLoanMarginTiers (params?: {}): Promise<List>;
    publicMarginGetCurrencyPairs (params?: {}): Promise<List>;
    publicMarginGetCurrencyPairsCurrencyPair (params?: {}): Promise<Dict>;
    publicMarginGetFundingBook (params?: {}): Promise<List>;
    publicMarginGetCrossCurrencies (params?: {}): Promise<List>;
    publicMarginGetCrossCurrenciesCurrency (params?: {}): Promise<Dict>;
    publicFlash_swapGetCurrencyPairs (params?: {}): Promise<List>;
    publicFlash_swapGetCurrencies (params?: {}): Promise<List>;
    publicFuturesGetSettleContracts (params?: {}): Promise<List>;
    publicFuturesGetSettleContractsContract (params?: {}): Promise<Dict>;
    publicFuturesGetSettleOrderBook (params?: {}): Promise<Dict>;
    publicFuturesGetSettleTrades (params?: {}): Promise<List>;
    publicFuturesGetSettleCandlesticks (params?: {}): Promise<List>;
    publicFuturesGetSettlePremiumIndex (params?: {}): Promise<List>;
    publicFuturesGetSettleTickers (params?: {}): Promise<List>;
    publicFuturesGetSettleFundingRate (params?: {}): Promise<List>;
    publicFuturesGetSettleInsurance (params?: {}): Promise<List>;
    publicFuturesGetSettleContractStats (params?: {}): Promise<List>;
    publicFuturesGetSettleIndexConstituentsIndex (params?: {}): Promise<Dict>;
    publicFuturesGetSettleLiqOrders (params?: {}): Promise<List>;
    publicFuturesGetSettleRiskLimitTiers (params?: {}): Promise<List>;
    publicFuturesGetSettleAdlRiskStates (params?: {}): Promise<List>;
    publicFuturesPostSettleFundingRates (params?: {}): Promise<List>;
    publicDeliveryGetSettleContracts (params?: {}): Promise<List>;
    publicDeliveryGetSettleContractsContract (params?: {}): Promise<Dict>;
    publicDeliveryGetSettleOrderBook (params?: {}): Promise<Dict>;
    publicDeliveryGetSettleTrades (params?: {}): Promise<List>;
    publicDeliveryGetSettleCandlesticks (params?: {}): Promise<List>;
    publicDeliveryGetSettleTickers (params?: {}): Promise<List>;
    publicDeliveryGetSettleInsurance (params?: {}): Promise<List>;
    publicDeliveryGetSettleRiskLimitTiers (params?: {}): Promise<List>;
    publicOptionsGetUnderlyings (params?: {}): Promise<List>;
    publicOptionsGetExpirations (params?: {}): Promise<List>;
    publicOptionsGetContracts (params?: {}): Promise<List>;
    publicOptionsGetContractsContract (params?: {}): Promise<Dict>;
    publicOptionsGetSettlements (params?: {}): Promise<List>;
    publicOptionsGetSettlementsContract (params?: {}): Promise<Dict>;
    publicOptionsGetOrderBook (params?: {}): Promise<Dict>;
    publicOptionsGetTickers (params?: {}): Promise<List>;
    publicOptionsGetUnderlyingTickersUnderlying (params?: {}): Promise<Dict>;
    publicOptionsGetCandlesticks (params?: {}): Promise<List>;
    publicOptionsGetUnderlyingCandlesticks (params?: {}): Promise<List>;
    publicOptionsGetTrades (params?: {}): Promise<List>;
    publicEarnGetUniCurrencies (params?: {}): Promise<List>;
    publicEarnGetUniCurrenciesCurrency (params?: {}): Promise<Dict>;
    publicEarnGetDualInvestmentPlan (params?: {}): Promise<List>;
    publicEarnGetStructuredProducts (params?: {}): Promise<List>;
    publicEarnGetDualProjectRecommend (params?: {}): Promise<List>;
    publicEarnGetFixedTermProduct (params?: {}): Promise<List>;
    publicEarnGetFixedTermProductAssetList (params?: {}): Promise<List>;
    publicLoanGetCollateralCurrencies (params?: {}): Promise<List>;
    publicLoanGetMultiCollateralCurrencies (params?: {}): Promise<Dict>;
    publicLoanGetMultiCollateralLtv (params?: {}): Promise<Dict>;
    publicLoanGetMultiCollateralFixedRate (params?: {}): Promise<List>;
    publicLoanGetMultiCollateralCurrentRate (params?: {}): Promise<List>;
    privateWithdrawalsPostWithdrawals (params?: {}): Promise<Dict>;
    privateWithdrawalsPostPush (params?: {}): Promise<Dict>;
    privateWithdrawalsDeleteWithdrawalsWithdrawalId (params?: {}): Promise<Dict>;
    privateWalletGetDepositAddress (params?: {}): Promise<Dict>;
    privateWalletGetWithdrawals (params?: {}): Promise<List>;
    privateWalletGetDeposits (params?: {}): Promise<List>;
    privateWalletGetSubAccountTransfers (params?: {}): Promise<List>;
    privateWalletGetOrderStatus (params?: {}): Promise<Dict>;
    privateWalletGetWithdrawStatus (params?: {}): Promise<List>;
    privateWalletGetSubAccountBalances (params?: {}): Promise<List>;
    privateWalletGetSubAccountMarginBalances (params?: {}): Promise<List>;
    privateWalletGetSubAccountFuturesBalances (params?: {}): Promise<List>;
    privateWalletGetSubAccountCrossMarginBalances (params?: {}): Promise<List>;
    privateWalletGetSavedAddress (params?: {}): Promise<List>;
    privateWalletGetFee (params?: {}): Promise<Dict>;
    privateWalletGetTotalBalance (params?: {}): Promise<Dict>;
    privateWalletGetSmallBalance (params?: {}): Promise<List>;
    privateWalletGetSmallBalanceHistory (params?: {}): Promise<List>;
    privateWalletGetPush (params?: {}): Promise<List>;
    privateWalletGetGetLowCapExchangeList (params?: {}): Promise<List>;
    privateWalletGetTransfers (params?: {}): Promise<Dict>;
    privateWalletPostTransfers (params?: {}): Promise<Dict>;
    privateWalletPostSubAccountTransfers (params?: {}): Promise<Dict>;
    privateWalletPostSubAccountToSubAccount (params?: {}): Promise<Dict>;
    privateWalletPostSmallBalance (params?: {}): Promise<Dict>;
    privateSubAccountsGetSubAccounts (params?: {}): Promise<List>;
    privateSubAccountsGetSubAccountsUserId (params?: {}): Promise<Dict>;
    privateSubAccountsGetSubAccountsUserIdKeys (params?: {}): Promise<List>;
    privateSubAccountsGetSubAccountsUserIdKeysKey (params?: {}): Promise<Dict>;
    privateSubAccountsPostSubAccounts (params?: {}): Promise<Dict>;
    privateSubAccountsPostSubAccountsUserIdKeys (params?: {}): Promise<Dict>;
    privateSubAccountsPostSubAccountsUserIdLock (params?: {}): Promise<Dict>;
    privateSubAccountsPostSubAccountsUserIdUnlock (params?: {}): Promise<Dict>;
    privateSubAccountsPutSubAccountsUserIdKeysKey (params?: {}): Promise<Dict>;
    privateSubAccountsDeleteSubAccountsUserIdKeysKey (params?: {}): Promise<Dict>;
    privateUnifiedGetAccounts (params?: {}): Promise<Dict>;
    privateUnifiedGetBorrowable (params?: {}): Promise<Dict>;
    privateUnifiedGetTransferable (params?: {}): Promise<Dict>;
    privateUnifiedGetTransferables (params?: {}): Promise<List>;
    privateUnifiedGetBatchBorrowable (params?: {}): Promise<List>;
    privateUnifiedGetLoans (params?: {}): Promise<List>;
    privateUnifiedGetLoanRecords (params?: {}): Promise<List>;
    privateUnifiedGetInterestRecords (params?: {}): Promise<List>;
    privateUnifiedGetRiskUnits (params?: {}): Promise<Dict>;
    privateUnifiedGetUnifiedMode (params?: {}): Promise<Dict>;
    privateUnifiedGetEstimateRate (params?: {}): Promise<Dict>;
    privateUnifiedGetCurrencyDiscountTiers (params?: {}): Promise<List>;
    privateUnifiedGetLoanMarginTiers (params?: {}): Promise<List>;
    privateUnifiedGetLeverageUserCurrencyConfig (params?: {}): Promise<Dict>;
    privateUnifiedGetLeverageUserCurrencySetting (params?: {}): Promise<List>;
    privateUnifiedGetDeltaNeutral (params?: {}): Promise<Dict>;
    privateUnifiedGetEstimatedQuickRepayment (params?: {}): Promise<Dict>;
    privateUnifiedGetAccountMode (params?: {}): Promise<Dict>;
    privateUnifiedPostLoans (params?: {}): Promise<Dict>;
    privateUnifiedPostPortfolioCalculator (params?: {}): Promise<Dict>;
    privateUnifiedPostLeverageUserCurrencySetting (params?: {}): Promise<List>;
    privateUnifiedPostCollateralCurrencies (params?: {}): Promise<Dict>;
    privateUnifiedPostDeltaNeutral (params?: {}): Promise<Dict>;
    privateUnifiedPostLeverageUserSetting (params?: {}): Promise<Dict>;
    privateUnifiedPostQuickRepayment (params?: {}): Promise<Dict>;
    privateUnifiedPostAccountMode (params?: {}): Promise<Dict>;
    privateUnifiedPutUnifiedMode (params?: {}): Promise<Dict>;
    privateSpotGetFee (params?: {}): Promise<Dict>;
    privateSpotGetBatchFee (params?: {}): Promise<Dict>;
    privateSpotGetAccounts (params?: {}): Promise<List>;
    privateSpotGetAccountBook (params?: {}): Promise<List>;
    privateSpotGetOpenOrders (params?: {}): Promise<List>;
    privateSpotGetOrders (params?: {}): Promise<List>;
    privateSpotGetOrdersOrderId (params?: {}): Promise<Dict>;
    privateSpotGetMyTrades (params?: {}): Promise<List>;
    privateSpotGetPriceOrders (params?: {}): Promise<List>;
    privateSpotGetPriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateSpotGetPovOrders (params?: {}): Promise<List>;
    privateSpotGetPovOrdersOrderId (params?: {}): Promise<Dict>;
    privateSpotPostBatchOrders (params?: {}): Promise<List>;
    privateSpotPostCrossLiquidateOrders (params?: {}): Promise<Dict>;
    privateSpotPostOrders (params?: {}): Promise<Dict>;
    privateSpotPostCancelBatchOrders (params?: {}): Promise<List>;
    privateSpotPostCountdownCancelAll (params?: {}): Promise<Dict>;
    privateSpotPostAmendBatchOrders (params?: {}): Promise<List>;
    privateSpotPostPriceOrders (params?: {}): Promise<Dict>;
    privateSpotPostPovOrders (params?: {}): Promise<Dict>;
    privateSpotDeleteOrders (params?: {}): Promise<List>;
    privateSpotDeleteOrdersOrderId (params?: {}): Promise<Dict>;
    privateSpotDeletePriceOrders (params?: {}): Promise<List>;
    privateSpotDeletePriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateSpotDeletePovOrders (params?: {}): Promise<List>;
    privateSpotDeletePovOrdersOrderId (params?: {}): Promise<Dict>;
    privateSpotPatchOrdersOrderId (params?: {}): Promise<Dict>;
    privateMarginGetAccounts (params?: {}): Promise<List>;
    privateMarginGetAccountBook (params?: {}): Promise<List>;
    privateMarginGetFundingAccounts (params?: {}): Promise<List>;
    privateMarginGetAutoRepay (params?: {}): Promise<Dict>;
    privateMarginGetTransferable (params?: {}): Promise<Dict>;
    privateMarginGetUniEstimateRate (params?: {}): Promise<Dict>;
    privateMarginGetUniLoans (params?: {}): Promise<List>;
    privateMarginGetUniLoanRecords (params?: {}): Promise<List>;
    privateMarginGetUniInterestRecords (params?: {}): Promise<List>;
    privateMarginGetUniBorrowable (params?: {}): Promise<Dict>;
    privateMarginGetUserLoanMarginTiers (params?: {}): Promise<List>;
    privateMarginGetUserAccount (params?: {}): Promise<List>;
    privateMarginGetLoans (params?: {}): Promise<List>;
    privateMarginGetLoansLoanId (params?: {}): Promise<Dict>;
    privateMarginGetLoansLoanIdRepayment (params?: {}): Promise<List>;
    privateMarginGetLoanRecords (params?: {}): Promise<List>;
    privateMarginGetLoanRecordsLoanRecordId (params?: {}): Promise<Dict>;
    privateMarginGetBorrowable (params?: {}): Promise<Dict>;
    privateMarginGetCrossAccounts (params?: {}): Promise<Dict>;
    privateMarginGetCrossAccountBook (params?: {}): Promise<List>;
    privateMarginGetCrossLoans (params?: {}): Promise<List>;
    privateMarginGetCrossLoansLoanId (params?: {}): Promise<Dict>;
    privateMarginGetCrossRepayments (params?: {}): Promise<List>;
    privateMarginGetCrossInterestRecords (params?: {}): Promise<List>;
    privateMarginGetCrossTransferable (params?: {}): Promise<Dict>;
    privateMarginGetCrossEstimateRate (params?: {}): Promise<Dict>;
    privateMarginGetCrossBorrowable (params?: {}): Promise<Dict>;
    privateMarginPostAutoRepay (params?: {}): Promise<Dict>;
    privateMarginPostUniLoans (params?: {}): Promise<Dict>;
    privateMarginPostLeverageUserMarketSetting (params?: {}): Promise<List>;
    privateMarginPostLoans (params?: {}): Promise<Dict>;
    privateMarginPostMergedLoans (params?: {}): Promise<Dict>;
    privateMarginPostLoansLoanIdRepayment (params?: {}): Promise<Dict>;
    privateMarginPostCrossLoans (params?: {}): Promise<Dict>;
    privateMarginPostCrossRepayments (params?: {}): Promise<List>;
    privateMarginPatchLoansLoanId (params?: {}): Promise<Dict>;
    privateMarginPatchLoanRecordsLoanRecordId (params?: {}): Promise<Dict>;
    privateMarginDeleteLoansLoanId (params?: {}): Promise<Dict>;
    privateFlash_swapGetOrders (params?: {}): Promise<List>;
    privateFlash_swapGetOrdersOrderId (params?: {}): Promise<Dict>;
    privateFlash_swapPostOrders (params?: {}): Promise<Dict>;
    privateFlash_swapPostOrdersPreview (params?: {}): Promise<Dict>;
    privateFuturesGetSettleAccounts (params?: {}): Promise<Dict>;
    privateFuturesGetSettleAccountBook (params?: {}): Promise<List>;
    privateFuturesGetSettlePositions (params?: {}): Promise<List>;
    privateFuturesGetSettlePositionsContract (params?: {}): Promise<Dict>;
    privateFuturesGetSettleGetLeverageContract (params?: {}): Promise<Dict>;
    privateFuturesGetSettleDualCompPositionsContract (params?: {}): Promise<List>;
    privateFuturesGetSettleOrders (params?: {}): Promise<List>;
    privateFuturesGetSettleOrdersTimerange (params?: {}): Promise<List>;
    privateFuturesGetSettleOrdersOrderId (params?: {}): Promise<Dict>;
    privateFuturesGetSettleMyTrades (params?: {}): Promise<List>;
    privateFuturesGetSettleMyTradesTimerange (params?: {}): Promise<List>;
    privateFuturesGetSettlePositionClose (params?: {}): Promise<List>;
    privateFuturesGetSettleLiquidates (params?: {}): Promise<List>;
    privateFuturesGetSettleAutoDeleverages (params?: {}): Promise<List>;
    privateFuturesGetSettleFee (params?: {}): Promise<Dict>;
    privateFuturesGetSettleRiskLimitTable (params?: {}): Promise<List>;
    privateFuturesGetSettlePriceOrders (params?: {}): Promise<List>;
    privateFuturesGetSettlePriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateFuturesGetSettleAutoorderV1TrailList (params?: {}): Promise<List>;
    privateFuturesGetSettleAutoorderV1TrailDetail (params?: {}): Promise<Dict>;
    privateFuturesGetSettleAutoorderV1TrailChangeLog (params?: {}): Promise<List>;
    privateFuturesGetSettleAutoorderV1ChaseList (params?: {}): Promise<List>;
    privateFuturesGetSettleAutoorderV1ChaseDetail (params?: {}): Promise<Dict>;
    privateFuturesPostSettlePositionsContractMargin (params?: {}): Promise<Dict>;
    privateFuturesPostSettlePositionsContractLeverage (params?: {}): Promise<Dict>;
    privateFuturesPostSettlePositionsContractSetLeverage (params?: {}): Promise<Dict>;
    privateFuturesPostSettlePositionsContractRiskLimit (params?: {}): Promise<Dict>;
    privateFuturesPostSettlePositionsCrossMode (params?: {}): Promise<Dict>;
    privateFuturesPostSettleDualCompPositionsCrossMode (params?: {}): Promise<List>;
    privateFuturesPostSettleDualMode (params?: {}): Promise<Dict>;
    privateFuturesPostSettleSetPositionMode (params?: {}): Promise<Dict>;
    privateFuturesPostSettleDualCompPositionsContractMargin (params?: {}): Promise<List>;
    privateFuturesPostSettleDualCompPositionsContractLeverage (params?: {}): Promise<List>;
    privateFuturesPostSettleDualCompPositionsContractRiskLimit (params?: {}): Promise<List>;
    privateFuturesPostSettleOrders (params?: {}): Promise<Dict>;
    privateFuturesPostSettleBatchOrders (params?: {}): Promise<List>;
    privateFuturesPostSettleCountdownCancelAll (params?: {}): Promise<Dict>;
    privateFuturesPostSettleBatchCancelOrders (params?: {}): Promise<List>;
    privateFuturesPostSettleBatchAmendOrders (params?: {}): Promise<List>;
    privateFuturesPostSettleBboOrders (params?: {}): Promise<Dict>;
    privateFuturesPostSettlePriceOrders (params?: {}): Promise<Dict>;
    privateFuturesPostSettleAutoorderV1TrailCreate (params?: {}): Promise<Dict>;
    privateFuturesPostSettleAutoorderV1TrailStop (params?: {}): Promise<Dict>;
    privateFuturesPostSettleAutoorderV1TrailStopAll (params?: {}): Promise<List>;
    privateFuturesPostSettleAutoorderV1TrailUpdate (params?: {}): Promise<Dict>;
    privateFuturesPostSettleAutoorderV1ChaseCreate (params?: {}): Promise<Dict>;
    privateFuturesPostSettleAutoorderV1ChaseStop (params?: {}): Promise<Dict>;
    privateFuturesPostSettleAutoorderV1ChaseStopAll (params?: {}): Promise<List>;
    privateFuturesPutSettleOrdersOrderId (params?: {}): Promise<Dict>;
    privateFuturesPutSettlePriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateFuturesDeleteSettleOrders (params?: {}): Promise<List>;
    privateFuturesDeleteSettleOrdersOrderId (params?: {}): Promise<Dict>;
    privateFuturesDeleteSettlePriceOrders (params?: {}): Promise<List>;
    privateFuturesDeleteSettlePriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeliveryGetSettleAccounts (params?: {}): Promise<Dict>;
    privateDeliveryGetSettleAccountBook (params?: {}): Promise<List>;
    privateDeliveryGetSettlePositions (params?: {}): Promise<List>;
    privateDeliveryGetSettlePositionsContract (params?: {}): Promise<Dict>;
    privateDeliveryGetSettleOrders (params?: {}): Promise<List>;
    privateDeliveryGetSettleOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeliveryGetSettleMyTrades (params?: {}): Promise<List>;
    privateDeliveryGetSettlePositionClose (params?: {}): Promise<List>;
    privateDeliveryGetSettleLiquidates (params?: {}): Promise<List>;
    privateDeliveryGetSettleSettlements (params?: {}): Promise<Dict>;
    privateDeliveryGetSettlePriceOrders (params?: {}): Promise<List>;
    privateDeliveryGetSettlePriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeliveryPostSettlePositionsContractMargin (params?: {}): Promise<Dict>;
    privateDeliveryPostSettlePositionsContractLeverage (params?: {}): Promise<Dict>;
    privateDeliveryPostSettlePositionsContractRiskLimit (params?: {}): Promise<Dict>;
    privateDeliveryPostSettleOrders (params?: {}): Promise<Dict>;
    privateDeliveryPostSettlePriceOrders (params?: {}): Promise<Dict>;
    privateDeliveryDeleteSettleOrders (params?: {}): Promise<List>;
    privateDeliveryDeleteSettleOrdersOrderId (params?: {}): Promise<Dict>;
    privateDeliveryDeleteSettlePriceOrders (params?: {}): Promise<List>;
    privateDeliveryDeleteSettlePriceOrdersOrderId (params?: {}): Promise<Dict>;
    privateOptionsGetMySettlements (params?: {}): Promise<Dict>;
    privateOptionsGetAccounts (params?: {}): Promise<Dict>;
    privateOptionsGetAccountBook (params?: {}): Promise<List>;
    privateOptionsGetPositions (params?: {}): Promise<List>;
    privateOptionsGetPositionsContract (params?: {}): Promise<Dict>;
    privateOptionsGetPositionClose (params?: {}): Promise<List>;
    privateOptionsGetOrders (params?: {}): Promise<List>;
    privateOptionsGetOrdersOrderId (params?: {}): Promise<Dict>;
    privateOptionsGetMyTrades (params?: {}): Promise<List>;
    privateOptionsGetMmp (params?: {}): Promise<List>;
    privateOptionsPostOrders (params?: {}): Promise<Dict>;
    privateOptionsPostCountdownCancelAll (params?: {}): Promise<Dict>;
    privateOptionsPostMmp (params?: {}): Promise<Dict>;
    privateOptionsPostMmpReset (params?: {}): Promise<Dict>;
    privateOptionsPutOrdersOrderId (params?: {}): Promise<Dict>;
    privateOptionsDeleteOrders (params?: {}): Promise<List>;
    privateOptionsDeleteOrdersOrderId (params?: {}): Promise<Dict>;
    privateEarnGetUniLends (params?: {}): Promise<List>;
    privateEarnGetUniLendRecords (params?: {}): Promise<List>;
    privateEarnGetUniInterestsCurrency (params?: {}): Promise<Dict>;
    privateEarnGetUniInterestRecords (params?: {}): Promise<List>;
    privateEarnGetUniInterestStatusCurrency (params?: {}): Promise<Dict>;
    privateEarnGetUniChart (params?: {}): Promise<List>;
    privateEarnGetUniRate (params?: {}): Promise<List>;
    privateEarnGetStakingEth2RateRecords (params?: {}): Promise<List>;
    privateEarnGetDualOrders (params?: {}): Promise<List>;
    privateEarnGetDualBalance (params?: {}): Promise<Dict>;
    privateEarnGetStructuredOrders (params?: {}): Promise<List>;
    privateEarnGetStakingCoins (params?: {}): Promise<List>;
    privateEarnGetStakingOrderList (params?: {}): Promise<Dict>;
    privateEarnGetStakingAwardList (params?: {}): Promise<Dict>;
    privateEarnGetStakingAssets (params?: {}): Promise<List>;
    privateEarnGetDualOrderRefundPreview (params?: {}): Promise<Dict>;
    privateEarnGetFixedTermUserLend (params?: {}): Promise<List>;
    privateEarnGetFixedTermUserHistory (params?: {}): Promise<List>;
    privateEarnGetAutoinvestCoins (params?: {}): Promise<List>;
    privateEarnGetAutoinvestConfig (params?: {}): Promise<List>;
    privateEarnGetAutoinvestOrders (params?: {}): Promise<List>;
    privateEarnGetAutoinvestPlansDetail (params?: {}): Promise<Dict>;
    privateEarnGetAutoinvestPlansListInfo (params?: {}): Promise<List>;
    privateEarnGetAutoinvestPlansRecords (params?: {}): Promise<List>;
    privateEarnGetUniCurrencies (params?: {}): Promise<List>;
    privateEarnGetUniCurrenciesCurrency (params?: {}): Promise<Dict>;
    privateEarnPostUniLends (params?: {}): Promise<List>;
    privateEarnPostStakingEth2Swap (params?: {}): Promise<Dict>;
    privateEarnPostDualOrders (params?: {}): Promise<Dict>;
    privateEarnPostStructuredOrders (params?: {}): Promise<List>;
    privateEarnPostStakingSwap (params?: {}): Promise<Dict>;
    privateEarnPostDualOrderRefund (params?: {}): Promise<Dict>;
    privateEarnPostDualModifyOrderReinvest (params?: {}): Promise<Dict>;
    privateEarnPostFixedTermUserLend (params?: {}): Promise<Dict>;
    privateEarnPostFixedTermUserPreRedeem (params?: {}): Promise<Dict>;
    privateEarnPostAutoinvestMinInvestAmount (params?: {}): Promise<Dict>;
    privateEarnPostAutoinvestPlansAddPosition (params?: {}): Promise<Dict>;
    privateEarnPostAutoinvestPlansCreate (params?: {}): Promise<Dict>;
    privateEarnPostAutoinvestPlansStop (params?: {}): Promise<Dict>;
    privateEarnPostAutoinvestPlansUpdate (params?: {}): Promise<Dict>;
    privateEarnPutUniInterestReinvest (params?: {}): Promise<Dict>;
    privateEarnPatchUniLends (params?: {}): Promise<List>;
    privateLoanGetCollateralOrders (params?: {}): Promise<List>;
    privateLoanGetCollateralOrdersOrderId (params?: {}): Promise<Dict>;
    privateLoanGetCollateralRepayRecords (params?: {}): Promise<List>;
    privateLoanGetCollateralCollaterals (params?: {}): Promise<List>;
    privateLoanGetCollateralTotalAmount (params?: {}): Promise<Dict>;
    privateLoanGetCollateralLtv (params?: {}): Promise<Dict>;
    privateLoanGetMultiCollateralOrders (params?: {}): Promise<List>;
    privateLoanGetMultiCollateralOrdersOrderId (params?: {}): Promise<Dict>;
    privateLoanGetMultiCollateralRepay (params?: {}): Promise<List>;
    privateLoanGetMultiCollateralMortgage (params?: {}): Promise<List>;
    privateLoanGetMultiCollateralCurrencyQuota (params?: {}): Promise<List>;
    privateLoanGetCollateralCurrencies (params?: {}): Promise<List>;
    privateLoanGetMultiCollateralCurrencies (params?: {}): Promise<Dict>;
    privateLoanGetMultiCollateralLtv (params?: {}): Promise<Dict>;
    privateLoanGetMultiCollateralFixedRate (params?: {}): Promise<List>;
    privateLoanGetMultiCollateralCurrentRate (params?: {}): Promise<List>;
    privateLoanPostCollateralOrders (params?: {}): Promise<Dict>;
    privateLoanPostCollateralRepay (params?: {}): Promise<Dict>;
    privateLoanPostCollateralCollaterals (params?: {}): Promise<List>;
    privateLoanPostMultiCollateralOrders (params?: {}): Promise<Dict>;
    privateLoanPostMultiCollateralRepay (params?: {}): Promise<Dict>;
    privateLoanPostMultiCollateralMortgage (params?: {}): Promise<Dict>;
    privateAccountGetDetail (params?: {}): Promise<Dict>;
    privateAccountGetMainKeys (params?: {}): Promise<Dict>;
    privateAccountGetRateLimit (params?: {}): Promise<List>;
    privateAccountGetStpGroups (params?: {}): Promise<List>;
    privateAccountGetStpGroupsStpIdUsers (params?: {}): Promise<List>;
    privateAccountGetStpGroupsDebitFee (params?: {}): Promise<Dict>;
    privateAccountGetDebitFee (params?: {}): Promise<Dict>;
    privateAccountPostStpGroups (params?: {}): Promise<Dict>;
    privateAccountPostStpGroupsStpIdUsers (params?: {}): Promise<List>;
    privateAccountPostDebitFee (params?: {}): Promise<Dict>;
    privateAccountDeleteStpGroupsStpIdUsers (params?: {}): Promise<List>;
    privateRebateGetAgencyTransactionHistory (params?: {}): Promise<List>;
    privateRebateGetAgencyCommissionHistory (params?: {}): Promise<List>;
    privateRebateGetPartnerTransactionHistory (params?: {}): Promise<Dict>;
    privateRebateGetPartnerCommissionHistory (params?: {}): Promise<Dict>;
    privateRebateGetPartnerSubList (params?: {}): Promise<Dict>;
    privateRebateGetBrokerCommissionHistory (params?: {}): Promise<List>;
    privateRebateGetBrokerTransactionHistory (params?: {}): Promise<List>;
    privateRebateGetUserInfo (params?: {}): Promise<List>;
    privateRebateGetUserSubRelation (params?: {}): Promise<Dict>;
    privateRebateGetPartnerDataAggregated (params?: {}): Promise<Dict>;
    privateOtcGetGetUserDefBank (params?: {}): Promise<Dict>;
    privateOtcGetOrderList (params?: {}): Promise<Dict>;
    privateOtcGetStableCoinOrderList (params?: {}): Promise<Dict>;
    privateOtcGetOrderDetail (params?: {}): Promise<Dict>;
    privateOtcGetBankList (params?: {}): Promise<List>;
    privateOtcGetBankBankSupplementChecklist (params?: {}): Promise<Dict>;
    privateOtcPostQuote (params?: {}): Promise<Dict>;
    privateOtcPostOrderCreate (params?: {}): Promise<Dict>;
    privateOtcPostStableCoinOrderCreate (params?: {}): Promise<Dict>;
    privateOtcPostOrderPaid (params?: {}): Promise<Dict>;
    privateOtcPostOrderCancel (params?: {}): Promise<Dict>;
    privateOtcPostBankCreate (params?: {}): Promise<Dict>;
    privateOtcPostBankDelete (params?: {}): Promise<Dict>;
    privateOtcPostBankSetDefault (params?: {}): Promise<Dict>;
    privateOtcPostBankPersonalBankSupplement (params?: {}): Promise<Dict>;
    privateOtcPostBankEnterpriseBankSupplement (params?: {}): Promise<Dict>;
    privateOtcPostUploadPreUpload (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
